<template>
<div>
  <v-card class="progress-container" v-if="initialLoading">
    <v-progress-circular :size="120" color="primary" indeterminate></v-progress-circular>
  </v-card>
  <div v-else>
    <v-layout>
      <v-container>
        <v-layout>
          <v-flex xs1>
            <FilterView v-on:filter="setUpFilter" />
          </v-flex>
          <v-flex offset-xs6 offset-lg9 xs1>
            <FilterNew v-on:filter="setUpFilter" />
          </v-flex>
        </v-layout>

        <!-- Filtracja data -->
        <v-layout row wrap>
          <v-flex lg5 md5 xs12>
            <v-select  :items="sortType" item-text="name" item-value="value" v-model="sort" :label="`${$t('archive.filter.sort')}`"></v-select>
          </v-flex>

          <v-flex lg5 md5 offset-md1 xs12>
            <v-select  :items="searchPlace" item-text="name" item-value="value" v-model="place" :label="`${$t('archive.filter.search_in')}`"></v-select>
          </v-flex>
          <v-flex lg2 md3 xs12>
            <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" :return-value.sync="dateFrom">
              <template slot="activator">
                <v-text-field v-model="dateFrom" :label="`${$t('cycle.from')}`" prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuFrom = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menuFrom.save(dateFrom)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex lg2 md3 xs12>
            <v-menu ref="menuTo" v-model="menuTo" :close-on-content-click="false" :nudge-right="40" :return-value.sync="dateTo">
              <template slot="activator">
                <v-text-field v-model="dateTo" :label="`${$t('cycle.to')}`" prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuTo = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menuTo.save(dateTo)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex lg3 md2 xs12 >
            <v-btn @click="resetDate" fab small>
              <v-icon small>close</v-icon>
            </v-btn>
            <v-btn @click="load" small fab>
              <v-icon small>refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Filtracja INFO -->
        <v-layout class="right-animation" v-if="filter.id!=0">
          <v-flex xs12>
            <v-card class="d-flex pa-2">
              <h3> {{ $t('archive.filter.choosen_filter') }} </h3>
            </v-card>
            <v-card class="pa-2">
              <v-badge right bordered overlap color="red">
                <template v-slot:badge>
                  <span>X</span>
                </template>
                <v-btn @click="clearFilter" class="white--text" color="green" depressed>
                  {{filter.name}}
                </v-btn>
              </v-badge>
            </v-card>
          </v-flex>
        </v-layout>


        <!-- Filtracja text -->

        <v-layout row wrap fluid class="left-animation" v-if="filter.id==0">
          <v-flex md5 xs12>
            <v-text-field v-model="search" :label="`${$t('archive.search')}`"></v-text-field>
          </v-flex>
          <v-flex md5 offset-md1 xs12>
            <v-select :items="sizes" v-model="size" :label="$t('archive.size') " class="input-group--focused" item-value="text"></v-select>
          </v-flex>
        </v-layout>

        <v-layout style="margin-top: 5rem;">
          <v-flex   offset-xs8 xs3>
            <v-icon style="float: right" @click="changeMode(3)" :color="mode == 3 ? 'primary' : 'gray'" class="icon">view_quilt</v-icon>
            <v-icon style="float: right" @click="changeMode(2)"  :color="mode == 2 ? 'primary' : 'gray'" class="icon">view_list</v-icon><!--    <v-icon>view_list</v-icon>-->
            <v-icon style="float: right" @click="changeMode(1)" :color="mode == 1 ? 'primary' : 'gray'" class="icon">toc</v-icon>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-container>
        <v-data-table  :rows-per-page-items="archivesData.length" v-if="mode == 1 " :headers="headers" :items="archivesData" class="elevation-1" :hide-actions="true"
                       no-data-text="Brak dokumentów"  :pagination.sync="paginationTbl">

          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.customName }}</td>
            <td class="text-xs-left">{{ props.item.archType }}</td>
            <td class="text-xs-left">{{ props.item.creationTime }}</td>
            <td class="text-xs-left">{{ props.item.modifyTime }}</td>
            <td>
              <v-btn  :disabled="!['2','3','4'].includes(props.item.document.status)" @click="openDocument(props.item)" small  icon>
                <v-icon color="green darken-3">pageview</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
          </v-container>
        </v-layout>

        <v-container fluid grid-list-lg v-if="mode == 3">
        <v-data-iterator no-data-text="Brak dokumentów" :rows-per-page-items="[3,6,9]" :pagination.sync="pagination"
                         content-tag="v-layout" row wrap :items="archivesData">
          <template v-slot:item="props">
            <v-flex xs12 sm12 md4 lg4  style="margin-top: 1rem;">
              <ArchiveCardView v-on:goToDocument="openDocument($event)"  :archiveOrgin="originArchivesData[archivesData.indexOf(props.item)]" :item="props.item"></ArchiveCardView>
            </v-flex>
          </template>
        </v-data-iterator>
        </v-container>

        <!-- Dane z archiwum -->
        <div v-if="mode == 2">
        <div  v-for="(archive,index) in archivesData" :key="archive.id">
          <v-container  row wrap grid-list-md text-xs-center>
            <div class="margin">
              <v-layout style="margin-bottom: 0.7rem">

              </v-layout>

              <v-layout row wrap>
                <v-flex lg2 md3 xs12>
                  <v-card>
                    <v-img contain aspect-ratio="1" max-height="256"  max-width="256" @click="openDocument(archive)" class="cursorPointner" :src="'data:image/png;base64,'+ archive.thumbImg"></v-img>
                  </v-card>
                </v-flex>

                <v-flex lg8 md7 xs12>
                  <v-layout row wrap>
                    <v-flex lg5 md5 xs6  offset-md1>
                      <v-text-field v-model="archive.customName" :label="`${$t('archive.file-name')}`" :readonly="!editMode"></v-text-field>
                    </v-flex>
                    <v-flex lg5 md5 xs6>
                      <v-text-field v-model="archive.archType" :label="`${$t('archive.arch_type')}`" :readonly="!editMode"></v-text-field>
                    </v-flex>

                  <v-flex lg5 md5 xs6 offset-md1>
                      <v-text-field v-model="archive.creationTime" :label="`${$t('archive.creation_date')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex lg5 md5 xs6>
                      <v-text-field v-model="archive.modifyTime" :label="`${$t('archive.modify_date')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>

                <v-flex lg2 md2 xs12>
                  <v-layout>
                    <v-flex lg6>
                      <EditArchive  :archive="archive" :archiveOrgin="originArchivesData[index]" />
                    </v-flex>
                    <v-flex lg6>
                      <v-btn color="green" :disabled="!['2','3','4'].includes(archive.document.status)" @click="openDocument(archive)">
                        {{ getDocumentText(archive) }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <hr>
          </v-container>
        </div>
        </div>
        <v-progress-linear indeterminate v-if="isLoading && (mode == 1 || mode == 2)"></v-progress-linear>
      </v-container>
    </v-layout>
  </div>
</div>
</template>

<script>
import http from '@/plugins/http'
import CreateForm from "@/components/archive/dialogs/CreateArchive"
import EditArchive from "@/components/archive/dialogs/EditArchive"
import FilterView from "@/components/archive/FilterView"
import FilterNew from "@/components/archive/FilterNew"
import DataTimeHelper from '@/plugins/DataTimeHelper'
import Messenger from "@/plugins/Messenger";
import ArchiveCardView from "@/components/document/archive/ArchiveCardView";

export default {
  components: {
    ArchiveCardView,
    CreateForm,
    FilterView,
    EditArchive,
    FilterNew
  },
  computed: {
    archives() {
      return this.archivesData
    }
  },
  data() {
    return {
      headers:[
        {text: 'Id',value: 'id'},
        {text: 'Nazwa pliku',value:'customName'},
        {text: 'Typ archiwum',value:'archType'},
        {text: 'Data stworzenia',value:'creationTime'},
        {text: 'Data modyfikacji',value:'modifyTime'},
        {text: 'Akcje'}
      ],
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 3,
        page : 1,
        totalItems: -1
      },
      paginationTbl: {
        rowsPerPage: -1,
        page : 1,
        totalItems: -1
      },
      isLoading : false,
      mode: 2,
      dateFrom: "",
      menuFrom: false,
      dateTo: "",
      menuTo: false,
      sort: "DESC",
      place: 2,
      editMode: false,
      chipVisible: false,
      block: false,
      i: 0,
      createDialog: false,
      archivesData: [],
      originArchivesData: [],
      search: "",
      previousSearchText: "",
      awaitingSearch: false,
      loadMoreAvailable: true,
      size: 10,
      sizes: [ 10, 20],
      initialLoading: false,
      filter: {
        id: 0,
        name: ""
      },
      searchPlace: [{
        name: this.$t('archive.filter.doc_and_note'),
        value: 2
      }, {
        name: this.$t('archive.filter.doc'),
        value: 1
      }, {
        name: this.$t('archive.filter.note'),
        value: 0
      }],
      sortType: [{
          name: this.$t('archive.filter.from_newest'),
          value: "DESC"
        },
        {
          name: this.$t('archive.filter.from_oldest'),
          value: "ASC"
        }
      ],
    }
  },
  methods: {
    changeMode(mode){
      this.mode = mode
    },
    load() {
      let filter = this.getTimeCondition();

      if (this.filter.id > 0) {
        let prefix = (filter.slice(-1) == "&")? "" : "&"
        filter = filter.concat(prefix + "filter=" + this.filter.id)
      }

      http.get('document/archive/find?' + "size=" + this.size +"&" + filter).then(data => {
        this.loadMoreAvailable =  (data.data.length < this.size)  ? false : true
        this.archivesData = data.data.sort((a, b) => {
          if (this.sort == "DESC") return b.id - a.id
          return a.id - b.id
        });

        this.originArchivesData = this.archivesData.map(a => Object.assign({}, a));
      }).finally(() => this.initialLoading = false)
    },
    loadNext() {
      this.loadMoreAvailable = false
      this.isLoading = true
      this.page++;
      let search = ""
      if (this.search != "")
        search = "/" + this.search

      let filter = "&" + this.getTimeCondition()
      if (this.filter.id > 0) {
        let prefix = (filter.slice(-1) == "&") ? "" : "&"
        filter  += prefix + "filter=" + this.filter.id
      }

      http.get('document/archive/find' + search + "?offset=" + this.archivesData.length + "&size=" + this.size + filter).then(data => {
        let newArchives = data.data.filter(el => undefined == this.archivesData.find(archive => archive.id == el.id));
        this.addNewArchives(newArchives)
        this.isLoading = false
      })
    },
    getTimeCondition() {
      let filter = ""
      if (this.dateFrom != undefined && this.dateFrom != "")
        filter = filter.concat("from=" + this.dateFrom + "&")
      if (this.dateTo != undefined && this.dateTo != "")
        filter = filter.concat("to=" + this.dateTo + "&")
      if (this.sort != undefined && this.sort != "")
        filter = filter.concat("sort=" + this.sort + "&")
      if (this.place !== undefined && this.place !== "")
        filter = filter.concat("place=" + this.place + "&")


      return filter
    },
    addNewArchives(newArchives) {
      this.loadMoreAvailable =  (newArchives.length < this.size)  ? false : true
      if (newArchives.length < this.size) {
        this.$store.commit("setSnack", {
          message: this.$t('archive.loaded', {
            count: newArchives.length
          }),
          color: "warning"
        })
      }
      let sorted = newArchives.sort((a, b) => {
        if (this.sort == "DESC") return b.id - a.id
        return a.id - b.id
      });

      this.archivesData = this.archivesData.concat(sorted)
      this.originArchivesData = this.originArchivesData.concat(sorted.map(a => Object.assign({}, a)));
    },
    formUploaded(data) {
      this.createDialog = false
      if (data.data.Status == "SS_OK" && data.data.MainPid != undefined) {
        this.$store.commit("setSnack", {
          message: this.$t('archive.process'),
          color: "warning"
        })
        this.requestArchiveStatus(data.data.MainPid)
      } else {
        this.showAdedError()
      }
    },
    requestArchiveStatus(id) {
      let bindComp = this
      let interval = setInterval(function() {
        http.get('archives/status/' + id).then(data => {
          if (data.data.Status == "SS_OK" && data.data.ArchiveFile != undefined) {
            if (data.data.ArchiveFile.RTEngineStatus == "RTPES_DONE") {
              clearInterval(interval);
              bindComp.getArchive(id)
              bindComp.showAdedSucces()
            }
            if (data.data.ArchiveFile.RTEngineStatus == "RTPES_ERROR") {
              bindComp.showAdedError()
              clearInterval(interval);
            }
          }
        }).catch(() => {
          clearInterval(interval);
          this.showAdedError()
        })
      }, 1500);
    },
    isEdited(archive, field) {
      let archiveOrgin = this.originArchivesData.find(el => archive.id == el.id)
      if (archiveOrgin == undefined)
        return false


      if (archive[field] != archiveOrgin[field]) {
        if (!this.block) {
          this.chipVisible = true
          this.block = true;

          setTimeout(() => {
            this.chipVisible = false
          }, 3000)

        }
        return true;
      }

      return false
    },
    update(archive, field) {
      let dataUpdate = {}
      dataUpdate[field] = archive[field]
      http.put('archive/' + archive.id, dataUpdate).then((data) => {
        if (data.data.status == "SS_OK") {
          let orgArch = this.originArchivesData.find(el => el.id == archive.id)
          orgArch[field] = archive[field]
          archive.modifyTime = DataTimeHelper.getDateTime()
          orgArch.modifyTime = DataTimeHelper.getDateTime()
        }
      })
    },
    setUpFilter(data) {
      this.filter = data
      this.load()
    },
    clearFilter() {
      this.filter = {
        name: '',
        id: 0
      }
      this.loadMoreAvailable = true
      this.load()
    },
    resetDate() {
      this.dateTo = ""
      this.dateFrom = ""
    },
    getArchive(id) {
      http.get('archives/get/' + id).then(data => {
        this.archivesData = data.data.concat(this.archivesData)
      }).catch(() => {
        this.showAdedError()
      })
    },
    showAdedError() {
      this.$store.commit("setSnack", {
        message: this.$t('archive.upload_error'),
        color: "danger"
      })
    },
    showAdedSucces() {
      this.$store.commit("setSnack", {
        message: this.$t('archive.added'),
        color: "success"
      })
    },
    open(id) {
      this.$store.commit("setSnack", {
        message: this.$t('archive.image_downloading'),
        color: "success",
        timeout: 1000
      })

      http.get('archives/show/' + id).then(data => {
        if (data.data.type == "image/tiff") {
          window.open('data:' + data.data.type + ";base64," + encodeURI(data.data.data), '_blank');
        } else {
          let win = window.open("")
          win.document.write('<iframe width=\'100%\' height=\'100%\' src=\'data:' + data.data.type + ";base64," + encodeURI(data.data.data) + "'></iframe>");
        }
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t('archive.image_error'),
          color: "success",
        })
      })
    },
    getDocumentText(archive){
      switch (parseInt(archive.document.status)){
        case 2: return "Poczekalnia"
        case 3:
        case 4:
        default: return "Dokument"
      }
    },
    openDocument(archive) {
      if(archive.document.status == '2'){
        return this.$router.push({ name: 'document-create-form',
          params : {documentId : archive.document.id,} })
      }

      if(archive.document == null || archive.document.schema == null || archive.document.schema.id == null || archive.document.form_id == null){
        return Messenger.emitError("Nie można otworzyć dokumentu")
      }

      if(archive.document.status == '3' || archive.document.status == '4'){
        return this.$router.push({ name: 'document-form-edit',
          params : {schemaId : archive.document.schema.id, formId : archive.document.form_id} })
      }

      return Messenger.emitError("Nie można otworzyć dokumentu")
    },
    lazyLoading(){
      window.onscroll = () => {
        let toDown = document.body.offsetHeight- innerHeight - scrollY
        let factor = this.mode ==1 ? 0.3 : 0.15
        if (toDown < document.body.offsetHeight * factor && this.loadMoreAvailable && (this.mode == 1 || this.mode == 2)) {
          this.loadNext()
        }
      }
    }
  },
  mounted() {
    this.lazyLoading()
  },
  created() {
    this.initialLoading = true;
    this.load();
    this.$store.dispatch('loadArchiveFilters')
  },
  watch: {
    'pagination.page': {
      deep: true,
      handler(){
        if(this.loadMoreAvailable && ((this.pagination.page * this.pagination.rowsPerPage) >= (this.archivesData.length - (2*this.pagination.rowsPerPage)))){
            this.loadNext()
        }
    }
  },
    'paginationTbl.page': {
      deep: true,
      handler(){
        if(this.loadMoreAvailable && ((this.paginationTbl.page * this.paginationTbl.rowsPerPage) >= (this.archivesData.length - (2*this.paginationTbl.rowsPerPage)))){
            this.loadNext()
        }
    }
  },
    search: function() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          let search = ""
          if (this.search != "")
            search = "/" + this.search
          this.previousSearchText = this.search

          let filter = "".concat("&" + this.getTimeCondition())

          http.get('document/archive/find' + search + "?size=" + this.size + filter).then(data => {
            this.archivesData = []
            this.loadMoreAvailable = true
            this.addNewArchives(data.data)
          }).catch(() => this.loadMoreAvailable = true)

          this.awaitingSearch = false;
        }, 1200); // 1.2 sec delay
      }
      this.awaitingSearch = true;
    },
    sort: function() {
      this.load()
    },
    place: function() {
      this.load()
    }
  }
}
</script>

<style scoped>
.margin {
  margin-bottom: 5rem;
  margin-top: 2.5rem;
}

.btn-edit {
  background-color: green !important
}

.inEditing {
  background-color: #e8eaf6;
  border-radius: 10px 10px;
}

.cursorPointner {
  cursor: pointer;
  object-fit: contain;
}

.edit-Text {
  position: fixed;
  top: 0.7rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  text-shadow: 1px 1px silver;
}

.loadNext {
  width: 100%;
  background-color: #af4a63;
  color: white;
  padding: 1.5rem 1.5rem;
  border-radius: 1rem;
}

.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.right-animation {
  animation-duration: 0.5s;
  animation-name: rightAnimation;
}

.left-animation {
  animation-duration: 0.5s;
  animation-name: leftAnimation;
}

@media only screen and (max-width: 600px) {
  .edit-Text {
    display: none;
  }
}

@keyframes rightAnimation {
  0% {
    -webkit-transform: translateX(-50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes leftAnimation {
  0% {
    -webkit-transform: translateX(50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(-10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}
</style>
